module.exports = __webpack_public_path__ + "img/icn_close.dbc9fc6f.svg";